/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationState } from './OrganizationState';
import {
    OrganizationStateFromJSON,
    OrganizationStateFromJSONTyped,
    OrganizationStateToJSON,
    OrganizationStateToJSONTyped,
} from './OrganizationState';

/**
 * 
 * @export
 * @interface FindAllOrganizationStates200Response
 */
export interface FindAllOrganizationStates200Response {
    /**
     * List of organization states
     */
    data?: Array<OrganizationState>;
}

/**
 * Check if a given object implements the FindAllOrganizationStates200Response interface.
 */
export function instanceOfFindAllOrganizationStates200Response(value: object): value is FindAllOrganizationStates200Response {
    return true;
}

export function FindAllOrganizationStates200ResponseFromJSON(json: any): FindAllOrganizationStates200Response {
    return FindAllOrganizationStates200ResponseFromJSONTyped(json, false);
}

export function FindAllOrganizationStates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllOrganizationStates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrganizationStateFromJSON)),
    };
}

export function FindAllOrganizationStates200ResponseToJSON(json: any): FindAllOrganizationStates200Response {
    return FindAllOrganizationStates200ResponseToJSONTyped(json, false);
}

export function FindAllOrganizationStates200ResponseToJSONTyped(value?: FindAllOrganizationStates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrganizationStateToJSON)),
    };
}

